import React from 'react';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { TextField, TextFieldProps } from '@mui/material';
import { useIntl } from 'react-intl';
import { ErrorPresentation } from 'helpers/validators';

export interface ValidatedTextFieldProps extends Omit<TextFieldProps, 'error' | 'helperText'> {
  fieldError?: ErrorPresentation;
}

export function ValidatedTextField({
  fieldError,
  ...props
}: ValidatedTextFieldProps): React.ReactElement {
  const intl = useIntl();

  const helperText = fieldError
    ? formatTranslation(intl, unsafeTranslationKey(fieldError.helperText?.id || 'validation_required') , fieldError.values
      )
    : undefined;

  return (
    <TextField
      {...props}
      error={Boolean(fieldError)}
      helperText={helperText}
    />
  );
}

export const MemoValidatedTextField = React.memo(ValidatedTextField);
